import {
  collection,
  addDoc,
  getDocs,
  query,
  orderBy,
  where,
  doc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  onSnapshot
} from "firebase/firestore";

import { db } from "../firebase";

export const subscribeProjects = (callback) => {
  const q = query(
    collection(db, "projects"),
    orderBy("createdAt", "desc")
  );

  return onSnapshot(q, (snapshot) => {
    const data = snapshot.docs.map((doc) => ({
      id: doc.id,
      ...doc.data()
    }));

    callback(data);
  });
};

export const createProject = async (projectData) => {
  return await addDoc(collection(db, "projects"), {
    ...projectData,
    createdAt: serverTimestamp()
  });
};

export const updateProjectById = async (id, data) => {
  return await updateDoc(doc(db, "projects", id), data);
};

export const archiveProjectById = async (id, data = {}) => {
  return await updateDoc(doc(db, "projects", id), {
    isArchived: true,
    archivedAt: serverTimestamp(),
    ...data
  });
};

export const deleteProjectById = async (id) => {
  return await deleteDoc(doc(db, "projects", id));
};

export const getProjectBySTB = async (stbCode) => {
  const q = query(
    collection(db, "projects"),
    where("projeStbKodu", "==", stbCode)
  );

  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const projectDoc = snapshot.docs[0];

  return {
    id: projectDoc.id,
    ...projectDoc.data()
  };
};

export const getProjectBySTBCompanyAndName = async ({
  stbCode,
  companyName,
  projectName
}) => {
  const q = query(
    collection(db, "projects"),
    where("projeStbKodu", "==", stbCode),
    where("firmaAdi", "==", companyName),
    where("projeAdi", "==", projectName)
  );

  const snapshot = await getDocs(q);

  if (snapshot.empty) {
    return null;
  }

  const projectDoc = snapshot.docs[0];

  return {
    id: projectDoc.id,
    ...projectDoc.data()
  };
};
